import { AiInsights_AiInsightListItem_Type as AiInsightListItem_Type } from '@zendesk/zqa-services/autoqa'
import { AutoQaSpotlightType } from '@/types/spotlight'
import { AutoQaCategoryType } from '@/types/category'

import { AutoValidationError } from '@/modules/settings/components/ai/types'
import type { DeconstructedOption } from '@/modules/conversations/utils/filters'
import i18n from '@/i18n'

export const systemSpotlightMap = {
  [AiInsightListItem_Type.DEAD_AIR]: AutoQaSpotlightType.DeadAir,
  [AiInsightListItem_Type.RECORDING_DISCLOSURE]: AutoQaSpotlightType.RecordingDisclosure,
}

export const systemCategoryMap = {
  [AiInsightListItem_Type.COMPREHENSION]: AutoQaCategoryType.Comprehension,
}

export const includesHandledValidationError = (error: string) => {
  const errorsArray = error.split(';').map((error) => error.trim())
  const enumValues: string[] = Object.values(AutoValidationError)
  return errorsArray.some((error) => enumValues.includes(error.toLowerCase()))
}

export const mapFilterOptions = (options: DeconstructedOption[]) =>
  options.map(({ option, condition }) => ({
    option: option.name,
    condition: condition.name,
  }))

enum FeDefinedAiInsightListItem_Type {
  ISSUE_UNDERSTANDING = 'ISSUE_UNDERSTANDING',
}

const spotlightTranslationKeys = {
  name: {
    [AiInsightListItem_Type.DEAD_AIR]: 'settings.spotlight.deadair.title',
    [AiInsightListItem_Type.RECORDING_DISCLOSURE]: 'settings.spotlight.recording_disclosure.title',
  },
  description: {
    [AiInsightListItem_Type.DEAD_AIR]: 'settings.ai.spotlights.dead_air.description',
    [AiInsightListItem_Type.RECORDING_DISCLOSURE]: 'settings.ai.spotlights.recording_disclosure.description',
  },
}

const categoryTranslationKeys = {
  name: {
    [AiInsightListItem_Type.COMPREHENSION]:
      'settings.workspaces.rating_categories.edit.auto_categories.issue_understanding.name',
    [AiInsightListItem_Type.EMPATHY]: 'settings.workspaces.rating_categories.edit.auto_categories.empathy.name',
    [AiInsightListItem_Type.GREETING]: 'settings.workspaces.rating_categories.edit.auto_categories.greeting.name',
    [AiInsightListItem_Type.CLOSING]: 'settings.workspaces.rating_categories.edit.auto_categories.closing.name',
    [AiInsightListItem_Type.GRAMMAR]: 'settings.workspaces.rating_categories.edit.auto_categories.grammar.name',
    [AiInsightListItem_Type.READABILITY]: 'settings.workspaces.rating_categories.edit.auto_categories.readability.name',
    [AiInsightListItem_Type.TONE]: 'settings.workspaces.rating_categories.edit.auto_categories.tone.name',
    [AiInsightListItem_Type.SOLUTION]: 'settings.workspaces.rating_categories.edit.auto_categories.solution.name',
    [FeDefinedAiInsightListItem_Type.ISSUE_UNDERSTANDING]:
      'settings.workspaces.rating_categories.edit.auto_categories.issue_understanding.name',
  },
  description: {
    [AiInsightListItem_Type.COMPREHENSION]: 'settings.ai.categories.issue_understanding.description',
    [AiInsightListItem_Type.EMPATHY]: 'settings.ai.categories.empathy.description',
    [AiInsightListItem_Type.GREETING]: 'settings.ai.categories.greeting.description',
    [AiInsightListItem_Type.CLOSING]: 'settings.ai.categories.closing.description',
    [AiInsightListItem_Type.GRAMMAR]: 'settings.ai.categories.grammar.description',
    [AiInsightListItem_Type.READABILITY]: 'settings.ai.categories.readability.description',
    [AiInsightListItem_Type.TONE]: 'settings.ai.categories.tone.description',
    [AiInsightListItem_Type.SOLUTION]: 'settings.ai.categories.solution.description',
    [FeDefinedAiInsightListItem_Type.ISSUE_UNDERSTANDING]: 'settings.ai.categories.issue_understanding.description',
  },
}

export function translateSystemCategoryName(code: string) {
  if (!code) return ''
  const key = categoryTranslationKeys.name[code.toUpperCase()]
  return key ? i18n.t(key) : ''
}

export function translateSystemCategoryDescription(code: string) {
  if (!code) return ''
  const key = categoryTranslationKeys.description[code.toUpperCase()]
  return key ? i18n.t(key) : ''
}

export function translateSystemSpotlightName(code: string) {
  if (!code) return ''
  const key = spotlightTranslationKeys.name[code.toUpperCase()]
  return key ? i18n.t(key) : ''
}

export function translateSystemSpotlightDescription(code: string) {
  if (!code) return ''
  const key = spotlightTranslationKeys.description[code.toUpperCase()]
  return key ? i18n.t(key) : ''
}
